import React from 'react';
import { percent } from "../../../helper/units.js";
import styles from "./SliderHandle.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function SliderHandle({
  index,
  stop,
  minValue,
  maxRange,
  elevation,
  onActive
}) {
  return /*#__PURE__*/_jsx("div", {
    className: styles.handle,
    style: {
      left: percent((stop - minValue) / maxRange),
      zIndex: elevation
    },
    onPointerDown: () => onActive(index)
  });
}